import React, { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import GlassIcon from './GlassIcon';
import type { ColorVariant } from '@/lib/colors';

interface CardHeaderProps {
  title: string;
  description?: string;
  icon: React.ElementType;
  variant?: ColorVariant;
  className?: string;
  actions?: ReactNode;
  iconSize?: number;
  iconClassName?: string;
}

/**
 * CardHeader component that displays a title with an icon using GlassIcon
 * Used for section headers throughout the application
 */
const CardHeader = ({
  title,
  description,
  icon,
  variant = 'blue',
  className,
  actions,
  iconSize = 20,
  iconClassName,
}: CardHeaderProps) => {
  return (
    <div className={cn('flex items-center justify-between', className)}>
      <div className="flex items-center space-x-3">
        <GlassIcon 
          icon={icon} 
          variant={variant} 
          size={iconSize}
          className={iconClassName}
        />
        <div className="flex flex-col justify-center">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
            {title}
          </h2>
          {description && (
            <p className="text-sm text-gray-600 dark:text-gray-300">
              {description}
            </p>
          )}
        </div>
      </div>
      {actions && (
        <div className="flex items-center space-x-2">
          {actions}
        </div>
      )}
    </div>
  );
};

export default CardHeader;
